import React from 'react';
import PropTypes from 'prop-types';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import './LayoutStaticText.scss';

const LayoutStaticText = (
  {
    content: {
      title,
      copy,
    },
    tabHeading: heading,
  }
) => {
  const sanitizedHeading = sanitizeString(heading);
  const sanitizedTitle = sanitizeString(title);
  const sanitizedCopy = sanitizeString(copy);

  return (
    <div className="LayoutStaticText">
      {heading && (
        <h3
          className="LayoutStaticText__heading"
          dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
            __html: sanitizedHeading,
          }}
        />
      )}
      <div className="LayoutStaticText__inner">
        <div
          className="LayoutStaticText__content"
        >
          <div className="LayoutStaticText__copy">
            {title && (
              <h3
                className="LayoutStaticText__title"
                dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                  __html: sanitizedTitle,
                }}
              />
            )}
            {copy && (
              <div
                dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                  __html: sanitizedCopy,
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

LayoutStaticText.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    copy: PropTypes.string,
  }).isRequired,
  tabHeading: PropTypes.string,
};

LayoutStaticText.defaultProps = {
  tabHeading: '',
};

export default LayoutStaticText;
